import { render, staticRenderFns } from "./showBIM.vue?vue&type=template&id=686af71c&"
import script from "./showBIM.vue?vue&type=script&lang=js&"
export * from "./showBIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports